export default __webpack_public_path__ + "static/media/customer02.18837033.jpg";